/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleRightIcon16Solid = forwardRef('ArrowFigureACircleRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0ZM3.484 8a.75.75 0 0 1 .75-.75H9.85L8.006 5.608a.75.75 0 0 1 .998-1.12l2.476 2.205a1.75 1.75 0 0 1 0 2.614l-2.476 2.205a.75.75 0 1 1-.998-1.12L9.85 8.75H4.234a.75.75 0 0 1-.75-.75Z" })));
});
